import { Atom, useAtom, useAtomValue, useSetAtom } from 'jotai';
import { defaultTableColumnsAtom, loadableTableConfigAtom, tableIdAtom, visibleTableColumnsAtom } from '@/atoms/table';
import { LOCKED_COLUMN_BY_TABLE_ID } from '@/consts/dataLocker/table';
import { withLockedColumn } from '@/utils/table';
import { useDeepEffect } from './useDeepEffect';

export const useSetDefaultAndVisibleTableColumns = (defaultTableColumnsDefinitionAtom: Atom<string[]>) => {
  const defaultTableColumnDefinitions = useAtomValue(defaultTableColumnsDefinitionAtom);

  const loadableTableConfig = useAtomValue(loadableTableConfigAtom);
  const [defaultTableColumns, setDefaultTableColumns] = useAtom(defaultTableColumnsAtom);
  const setVisibleTableColumns = useSetAtom(visibleTableColumnsAtom);
  const tableId = useAtomValue(tableIdAtom);

  useDeepEffect(() => {
    setDefaultTableColumns(defaultTableColumnDefinitions);
  }, [defaultTableColumnDefinitions]);

  useDeepEffect(() => {
    if (loadableTableConfig.state === 'hasData') {
      const userSavedColumns = loadableTableConfig.data.selectedColumns;
      const baseColumns = userSavedColumns.length ? userSavedColumns : defaultTableColumns;
      const lockedKey = tableId ? LOCKED_COLUMN_BY_TABLE_ID[tableId] : undefined;
      setVisibleTableColumns(withLockedColumn(baseColumns, lockedKey));
    }
  }, [defaultTableColumns, loadableTableConfig, tableId]);
};
